import React, { useRef } from 'react';
import './CtaButton.scss';
import contents from '../../contents';
// import ctaButtonImg from '../../Assets/ctaButtonImg.jpg';
// import ctaButtonArrow from '../../Assets/ctaButtonArrow.svg';

function CtaButton({ handleMouseLeaveTooltip, handleMouseEnterTooltip }) {
  const ctaTooltip = useRef();
  return (
    <>
      <a href={contents.ctaTooltip.href} target="_blank" rel="sponsored" className="cta cta__button">
      
          {/* <img src={ctaButtonImg} alt="girls" /> */}
        More Intel Stories

          {/* <img src={ctaButtonArrow} alt="triangle" /> */}
     
      </a>
      <div className="tooltip" ref={ctaTooltip}>
        <p className="tooltip__content">{contents.ctaTooltip.copy}</p>
      </div>
    </>
  );
}

export default CtaButton;
